module.exports = __webpack_public_path__ + "img/icon_team.7e7f9d10.png";